import { render } from "./DropdownSelect.vue?vue&type=template&id=0e9d3fe5&scoped=true&bindings={}"
import script from "./DropdownSelect.vue?vue&type=script&lang=ts"
export * from "./DropdownSelect.vue?vue&type=script&lang=ts"

import "./DropdownSelect.vue?vue&type=style&index=0&id=0e9d3fe5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0e9d3fe5"

export default script